import initMaxTodayDateValidator from '../native-validators/max-today-date';

export default class FormValidator {
    constructor(formEl, validators) {
        this.form = formEl;
        this.validatorsInstances = validators || [];

        this._initNativeValidators();
    }

    validate() {
        this.validatorsInstances.forEach(validator => validator.validate());
    }

    _initNativeValidators() {
        initMaxTodayDateValidator(this.form);
    }

    get isValid() {
        for (let i = 0; i < this.validatorsInstances.length; i++) {
            if (!this.validatorsInstances[i].isValid) {
                return false;
            }
        }

        return true;
    }

    destroy() {
        this.validatorsInstances.forEach((validator) => {
            validator.destroy();
        });
    }

    update(validators) {
        this.destroy();
        this._initNativeValidators();
        this.validatorsInstances = validators || [];
    } 
}
